import { External } from '../../external';

const BASE_URL = `https://${External.serviceApiDomain}/comment/admin`;
const CommentService = {
  getContexts: async () => {
    const url = `${BASE_URL}/context?resourceType=standalone`;
    const response = await fetch(url, {
      method: 'GET',
      cache: 'no-cache',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      }
    });
    // An error page parses as JSON just as happily as a thread list does; without this the
    // caller gets a non-array back and only finds out when .find() throws at it.
    if (!response.ok) {
      throw new Error('Unable to load comment threads: ' + response.status);
    }

    return await response.json();
  },
  createContext: async (name) => {
    const url = `${BASE_URL}/context`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      },
      body: JSON.stringify({
        name: name,
        resourceType: 'standalone',
        resourceId: new Date().getTime(),
        moderation: { writePermission: 2, approvalRequired: 2 },
        extra: {
          allowMentions: false,
          allowImages: false
        }
      })
    });

    return await response.json();
  },
  partialUpdateContext: async (resourceType, resourceId, partialUpdate) => {
    const url = `${BASE_URL}/context`;
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      },
      body: JSON.stringify({
        resourceType: resourceType,
        resourceId: resourceId,
        ...partialUpdate
      })
    });

    return await response.json();
  }
};

export default CommentService;
